import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const addDeliveryPriceToSDDSelector = createSelector(testTargetOffersSelector, offers => offers.addDeliveryPriceToSDD || Empty.Object);

export { addDeliveryPriceToSDDSelector };
